import script from "./Inform.vue?vue&type=script&setup=true&lang=js"
export * from "./Inform.vue?vue&type=script&setup=true&lang=js"

import "./Inform.vue?vue&type=style&index=0&id=61bb7361&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61bb7361"]])

export default __exports__